import type { Language } from "@app/constants";

interface Messages {
	button: string;
	contact: {
		email: string;
		resolve: string;
	};
	error: string;
	information: string;
	success: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		button: "OK",
		contact: {
			email: "info@futureforex.co.za",
			resolve: "If this persists please contact ",
		},
		error: "Apologies, you've encountered an error",
		information: "Information",
		success: "Success",
	},
};

export default messages;
